module.exports = __webpack_public_path__ + "img/home_bg.0a6c4e58.gif";